import Authenticate from "../_pages/Authenticate";
import UnAuthorized from "../_pages/UnAuthorized";
import TermsAndConditions from "../_pages/TermsAndConditions";
import AboutSalah from "../_pages/AboutSalah";

const PublicRoutes = [
  {
    path: "/unauthorized",
    element: <UnAuthorized />,
  },
  {
    path: "/authenticate",
    element: <Authenticate />,
  },


];

export default PublicRoutes;
